// extracted by mini-css-extract-plugin
export default {"icon":"ConnectWalletButton_icon__fOKPs"};